module.exports = __webpack_public_path__ + "static/monzo@2x-50aff407137e0baf2d62364a4b47e102.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/customer-stories/monzo@2x.jpg
// module id = 872
// module chunks = 33019919093843 122353984331245